import _axios from 'axios'

const API_URL = 'https://hub.snapshot.org/graphql'

const axios = _axios.create({
  baseURL: API_URL,
  timeout: 15000,
})

export interface IDaoProposal {
  author: string
  body: string
  choices: string[]
  end: number // timestamp
  id: string
  snapshot: string
  space: { id: string; name: string }
  start: number // timestamp
  state: string
  title: string
}

export async function getProposals(): Promise<IDaoProposal[]> {
  const payload = {
    query: `
    query Proposals {
        proposals(
          first: 20,
        skip: 0,
        where: {
            space: "ooki.eth"
        },
        orderBy: "created",
        orderDirection: desc
      ) {
          id
        title
        body
        choices
        start
        end
        snapshot
        state
        author
        space {
            id
          name
        }
      }
    }
    `,
    variables: null,
    operationName: 'Proposals',
  }

  const { data } = await axios.post('', payload)
  // There is a test proposal that we want to exclude from snapshot listing
  return data.data.proposals.filter((prop: IDaoProposal) => !prop.title.includes('test'))
}

export default {
  getProposals,
}
